import { createSelector } from "@ngrx/store";
import { DateTimeState } from "./datepicker.reducer";
import { AppState } from "../index.selector";

export const selectFeature = (state: AppState) => state.datetime;
export const selectFromTo = createSelector(
  selectFeature,
  (state: DateTimeState) => state,
);
